import { render, staticRenderFns } from "./Browser.vue?vue&type=template&id=21b0c820&"
import script from "./Browser.vue?vue&type=script&lang=ts&"
export * from "./Browser.vue?vue&type=script&lang=ts&"
import style0 from "./Browser.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports